import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import VivaIcon from './VivaIcon';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { HashLink } from 'react-router-hash-link';
import { Link as RouterLink } from 'react-router-dom';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', px: 0 }}>
            <HashLink to="/#home" smooth>
              <VivaIcon />
            </HashLink>
          </Box>
          <Box sx={{
            flexGrow: 1,
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <HashLink to="/#about" smooth>
              <Button variant="text" color="info" size="small">
                About
              </Button>
            </HashLink>
            <HashLink to="/#features" smooth>
              <Button variant="text" color="info" size="small">
              Features
              </Button>
            </HashLink>
            <HashLink to="/#integrations" smooth>
              <Button variant="text" color="info" size="small">
              Integrations
              </Button>
            </HashLink>
            <HashLink to="/#roadmap" smooth>
              <Button variant="text" color="info" size="small">
                Roadmap
              </Button>
            </HashLink>
            {/* <HashLink to="/#tokenomics" smooth>
              <Button variant="text" color="info" size="small">
                Tokenomics
              </Button>
            </HashLink> */}
            <HashLink to="/#faq" smooth>
              <Button variant="text" color="info" size="small">
                FAQ
              </Button>
            </HashLink>
            <RouterLink to="/careers" style={{ textDecoration: 'none' }}>
              <Button variant="text" color="info" size="small">
                Careers
              </Button>
            </RouterLink>
            {/* <Button
              variant="text"
              color="info"
              size="small"
              endIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
              href="https://vivachain.gitbook.io/viva-ai-resources"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resources
            </Button> */}
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              sx={{ minWidth: 110 }}
              href="https://chat.vivachain.ai"
            >
              Dashboard
            </Button>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  top: 'var(--template-frame-height, 0px)',
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>

                <HashLink to="/#about" smooth style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem>About</MenuItem>
                </HashLink>
                <HashLink to="/#features" smooth style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem>Features</MenuItem>
                </HashLink>
                <HashLink to="/#integrations" smooth style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem>Integrations</MenuItem>
                </HashLink>
                <HashLink to="/#roadmap" smooth style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem>Roadmap</MenuItem>
                </HashLink>
                <HashLink to="/#faq" smooth style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem>FAQ</MenuItem>
                </HashLink>
                <RouterLink to="/careers" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem>Careers</MenuItem>
                </RouterLink>
                {/* <Button
                  endIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
                  href="https://vivachain.gitbook.io/viva-ai-resources"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Resources
                </Button> */}
                <Divider sx={{ my: 3 }} />
                <MenuItem>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    href="https://localhost:5173"
                  >
                    Dashboard
                  </Button>
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
